import dalImg from "../assets/images/dal.jpg";
import gondolaImg from "../assets/images/gondola.jpg";

interface ImageProps {
  src: string;
  alt: string;
}

interface ICard {
  title: string;
  subheading: string;
  description: string;
  highlights: string[];
  duration: string;
  image?: ImageProps;
}

export const Activities: ICard[] = [
  // Existing activities
  {
    title: "Gondola Ride in Gulmarg",
    subheading:
      "Experience the world's highest cable car in the stunning landscapes of Gulmarg.",
    description:
      "Embark on a breathtaking journey aboard the Gulmarg Gondola, one of the most spectacular cable car rides in the world. Ascend to a staggering height of over 13,000 feet, where you'll be greeted by panoramic views of snow-capped peaks, dense forests, and the serene beauty of the Himalayas. Perfect for adventure seekers and nature lovers alike, this ride offers an unforgettable experience in the heart of Kashmir.",
    highlights: [
      "Phase 1: Take the ride to Kongdoori Station at 8,530 feet.",
      "Phase 2: Continue to the Apharwat Peak, reaching 13,450 feet.",
      "Duration: The entire ride takes about 20-30 minutes.",
    ],
    duration: "20-30 minutes",
    image: {
      src: gondolaImg,
      alt: "Gondola Ride in Gulmarg",
    },
  },
  {
    title: "Shikara Ride on Dal Lake",
    subheading: "Enjoy a serene Shikara ride on the iconic Dal Lake.",
    description:
      "Glide through the calm waters of Dal Lake and explore the floating gardens, markets, and the beauty of the surrounding landscapes. The Shikara ride offers a peaceful escape from the hustle and bustle, surrounded by breathtaking views of the Zabarwan mountain range.",
    highlights: [
      "Relax in a traditional Shikara boat.",
      "Witness the floating markets and gardens.",
      "Duration: Typically lasts 1-2 hours.",
    ],
    duration: "1-2 hours",
    image: {
      src: dalImg,
      alt: "Shikara Ride on Dal Lake",
    },
  },
  {
    title: "Trekking in Drung",
    subheading: "Explore the picturesque landscapes of Drung.",
    description:
      "Drung offers a serene trekking experience with its waterfalls, lush meadows, and panoramic views. This trek is ideal for those looking to connect with nature and escape into the tranquility of the mountains.",
    highlights: [
      "Discover the hidden waterfalls.",
      "Experience the lush green meadows.",
      "Duration: Trekking time is around 4-6 hours.",
    ],
    duration: "4-6 hours",
    image: {
      src: "/images/activities/drung.jpg",
      alt: "Trekking in Drung",
    },
  },
  {
    title: "ATV Ride in Gulmarg",
    subheading: "Thrill-seekers rejoice with an ATV adventure in Gulmarg.",
    description:
      "Race through the snow and rugged trails of Gulmarg on an All-Terrain Vehicle (ATV). An exhilarating experience perfect for adventure enthusiasts.",
    highlights: [
      "Navigate through challenging snow trails.",
      "Enjoy the scenic beauty of Gulmarg while riding.",
      "Duration: Rides last 30-60 minutes.",
    ],
    duration: "30-60 minutes",
    image: {
      src: "/images/activities/atv.jpg",
      alt: "ATV Ride in Gulmarg",
    },
  },
  {
    title: "Horse Ride in Gulmarg",
    subheading: "Enjoy a peaceful horse ride amidst Gulmarg’s beauty.",
    description:
      "Discover Gulmarg's breathtaking scenery on horseback. Suitable for all ages, this ride is a tranquil way to explore the valley's beauty.",
    highlights: [
      "Explore trails leading to scenic spots.",
      "Perfect for families and first-timers.",
      "Duration: Typically lasts 1-2 hours.",
    ],
    duration: "1-2 hours",
    image: {
      src: "/images/activities/horse.jpg",
      alt: "Horse Ride in Gulmarg",
    },
  },
  {
    title: "Skiing in Gulmarg",
    subheading: "Experience world-class skiing in the Himalayas.",
    description:
      "Gulmarg is a paradise for skiers, offering some of the best slopes in the world. Perfect for both beginners and seasoned skiers.",
    highlights: [
      "Ski lessons available for beginners.",
      "Explore Apharwat Peak for advanced skiing.",
      "Duration: Full-day or half-day options.",
    ],
    duration: "Half-day to Full-day",
    image: {
      src: "/images/courses/sk2.jpg",
      alt: "Skiing in Gulmarg",
    },
  },
  {
    title: "Snowboarding in Gulmarg",
    subheading: "Carve the slopes of Gulmarg on a snowboard.",
    description:
      "Join the growing community of snowboarders and experience the thrill of riding down Gulmarg's pristine snow-covered slopes.",
    highlights: [
      "Suitable for beginners and experts.",
      "Professional instructors available.",
      "Duration: Half-day to Full-day.",
    ],
    duration: "Half-day to Full-day",
    image: {
      src: "/images/courses/sb4.jpg",
      alt: "Snowboarding in Gulmarg",
    },
  },
  {
    title: "Helicopter Ride in Gulmarg",
    subheading: "Soar above the stunning landscapes of Gulmarg.",
    description:
      "Experience breathtaking aerial views of the Himalayas and Gulmarg’s snow-covered peaks. A thrilling adventure for everyone.",
    highlights: [
      "Panoramic views of the valley and peaks.",
      "Duration: Flights last 15-30 minutes.",
    ],
    duration: "15-30 minutes",
    image: {
      src: "/images/activities/helicopter.jpg",
      alt: "Helicopter Ride in Gulmarg",
    },
  },
  {
    title: "Bike Ride in Ladakh",
    subheading: "Explore Ladakh's rugged beauty on two wheels.",
    description:
      "Embark on an adventurous bike ride through Ladakh’s iconic routes, featuring stunning mountain passes and serene valleys.",
    highlights: [
      "Conquer Khardung La and other famous passes.",
      "Duration: Multi-day trips (5-10 days).",
    ],
    duration: "5-10 days",
    image: {
      src: "/images/activities/ladakh.jpg",
      alt: "Bike Ride in Ladakh",
    },
  },

  {
    title: "Rafting in Pahalgam",
    subheading: "Thrilling white-water rafting on the Lidder River.",
    description:
      "Feel the rush of white-water rafting in the Lidder River amidst the stunning scenery of Pahalgam. A must-try for adventure lovers.",
    highlights: [
      "Suitable for beginners and experienced rafters.",
      "Duration: Rafting sessions last 1-2 hours.",
    ],
    duration: "1-2 hours",
    image: {
      src: "/images/activities/rafting.jpg",
      alt: "Rafting in Pahalgam",
    },
  },
  {
    title: "Camping in Sonamarg",
    subheading: "Experience nature at its best with camping under the stars.",
    description:
      "Sonamarg offers an ideal spot for camping amidst lush meadows and snow-capped peaks. Connect with nature and enjoy the serene beauty of the valley.",
    highlights: [
      "Tents provided with all essential amenities.",
      "Perfect for stargazing and bonfires.",
      "Duration: Overnight camping options available.",
    ],
    duration: "Overnight",
    image: {
      src: "/images/activities/camping.jpg",
      alt: "Camping in Sonamarg",
    },
  },
  {
    title: "Paragliding in Pahalgam",
    subheading: "Soar like a bird over the picturesque valleys of Pahalgam.",
    description:
      "Get a bird’s-eye view of the breathtaking landscapes of Pahalgam while enjoying the thrill of paragliding. A must-try for adventure enthusiasts.",
    highlights: [
      "Trained instructors for a safe experience.",
      "Capture aerial views of valleys and rivers.",
      "Duration: 10-20 minutes per flight.",
    ],
    duration: "10-20 minutes",
    image: {
      src: "/images/activities/paragliding.jpg",
      alt: "Paragliding in Pahalgam",
    },
  },
  {
    title: "Tulip Garden Visit in Srinagar",
    subheading: "Marvel at Asia's largest tulip garden in full bloom.",
    description:
      "Indira Gandhi Memorial Tulip Garden is a visual treat with thousands of tulips blooming in various vibrant colors. A photographer’s paradise and a nature lover’s dream.",
    highlights: [
      "Best visited in March-April during blooming season.",
      "Located near Dal Lake with stunning views.",
      "Duration: 1-2 hours.",
    ],
    duration: "1-2 hours",
    image: {
      src: "/images/activities/tulip.jpg",
      alt: "Tulip Garden Visit in Srinagar",
    },
  },

  {
    title: "Apple Orchard Visit in Sopore",
    subheading: "Explore the lush apple orchards of Kashmir.",
    description:
      "Visit the apple orchards in Sopore, known as the 'Apple Town of Kashmir,' and taste fresh, juicy apples straight from the trees.",
    highlights: [
      "Seasonal tours available (August-October).",
      "Learn about apple cultivation and harvesting.",
      "Duration: 2-3 hours.",
    ],
    duration: "2-3 hours",
    image: {
      src: "/images/activities/apple.jpg",
      alt: "Apple Orchard Visit in Sopore",
    },
  },
];
